<template>
  <div class="fixed-in-bottom">
    <button
      :class="(isEmpty() || getCurrentRoute() == 'cart')? 'go-to-cart isnt-visible' : 'go-to-cart is-visible'"
      @click="navigateTo('cart')"
    >
      <i class="fas fa-shopping-cart"></i>
      <span>&nbsp; Finalizar</span>
    </button>

    <button
      :class="isVisible ? 'go-top is-visible' : 'go-top isnt-visible'"
      @click="backToTop"
    >
      <i class="fas fa-chevron-up"></i>
    </button>
    <button
      :class="!isVisible && !isEmpty() ? 'go-top is-visible' : 'go-top isnt-visible'"
      @click="goToCart"
    >
      <i class="fas fa-chevron-down"></i>
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "fixed-in-bottom",
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {
    ...mapGetters(["cart"]),
  },
  methods: {
    initToTopButton() {
      if (window.scrollY > 100) {
        this.isVisible = true
      }
      if (window.scrollY < 100) {
        this.isVisible = false
      }
    },
    isEmpty() {
      return this.cart.length < 1 ? true : false
    },
    backToTop() {
      window.scrollTo(0, 0)
    },
    goToCart() {
      const el = document.getElementsByClassName('cart-bottom')[0];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    navigateTo(name) {
      this.$router.push({ name })
    },
    getCurrentRoute() {
      return this.$route.name
    }
  },
  mounted() {
    window.addEventListener("scroll", this.initToTopButton)
  },
  watch: {},
};
</script>